import React from "react";
import DataTable from "react-data-table-component";
import { MdEdit, MdDelete } from "react-icons/md";

// Custom styles for font size
const customStyles = {
  headCells: {
    style: {
      fontSize: "16px",
      fontWeight: "semibold",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
    },
  },
  rows: {
    style: {
      height: "48px", 
    },
  },
};

const List = ({ data = [], onEdit, onDelete }) => {
  // Split data into three parts for side-by-side display
  const chunkSize = Math.ceil(data.length / 3);
  const col1Data = data.slice(0, chunkSize);
  const col2Data = data.slice(chunkSize, chunkSize * 2);
  const col3Data = data.slice(chunkSize * 2);

  const columns = [
    {
      name: "S.No",
      selector: (row) => row.originalIndex,
      center: true,
      width: "70px",
    },
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
      width: "250px",
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex items-center gap-3">
          <MdEdit
            className="text-blue-600 text-xl cursor-pointer"
            onClick={() => onEdit(row)}
          />
          <MdDelete
            className="text-red-600 text-xl cursor-pointer"
            onClick={() => onDelete(row.id)}
          />
        </div>
      ),
      width: "120px",
      center: true,
    },
  ];

  // Add original index to track S.No across columns
  const col1WithIndex = col1Data.map((item, index) => ({
    ...item,
    originalIndex: index + 1,
  }));

  const col2WithIndex = col2Data.map((item, index) => ({
    ...item,
    originalIndex: chunkSize + index + 1,
  }));

  const col3WithIndex = col3Data.map((item, index) => ({
    ...item,
    originalIndex: chunkSize * 2 + index + 1,
  }));

  return (
    <div className="mt-4">
      <div className="grid grid-cols-3 gap-3">
        {/* Left Column */}
        <div className="pr-2 border-r border-gray-300">
          <DataTable
            columns={columns}
            data={col1WithIndex}
            highlightOnHover
            dense
            customStyles={customStyles}
            noDataComponent={<div className="p-4 text-gray-500">No data available</div>}
          />
        </div>

        {/* Middle Column */}
  <div className="px-2 border-r border-gray-300">
          <DataTable
            columns={columns}
            data={col2WithIndex}
            highlightOnHover
            dense
            customStyles={customStyles}
            noDataComponent={<div className="p-4 text-gray-500">No data available</div>}
          />
        </div>

        {/* Right Column */}
  <div className="pl-2">
          <DataTable
            columns={columns}
            data={col3WithIndex}
            highlightOnHover
            dense
            customStyles={customStyles}
            noDataComponent={<div className="p-4 text-gray-500">No data available</div>}
          />
        </div>
      </div>
    </div>
  );
};

export default List;
